import React from "react";

import SharedEpisodesView from "../modules/SharedEpisodes/SharedEpisodesView";

export default function SharedEpisodes() {
  return <SharedEpisodesView />;
}
